// import React from "react";
// import { US_STATES } from "../../data/state";

// const AddressForm = ({
//   address,
//   setAddress,
//   onContinue,
//   fetchShippingRates,
// }) => {
//   const handleInputChange = (field, value) => {
//     setAddress((prev) => ({ ...prev, [field]: value }));
//   };

//   // const isFormValid = () => {
//   //   return address.name && address.address && address.city && address.state && address.zipCode;
//   // };

//   const isFormValid = () => {
//     return (
//       address.name &&
//       address.email &&
//       address.address &&
//       address.city &&
//       address.state &&
//       address.zipCode
//     );
//   };

//   const handleContinue = async () => {
//     if (fetchShippingRates) {
//       await fetchShippingRates(address);
//     }
//     onContinue();
//   };

//   return (
//     <div className="space-y-4">
//       <div>
//         <label className="block text-sm font-medium mb-1">Full Name</label>
//         <input
//           type="text"
//           value={address.name}
//           onChange={(e) => handleInputChange("name", e.target.value)}
//           className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent"
//           placeholder="John Doe"
//         />
//       </div>

//       {/* ADD THIS EMAIL FIELD HERE */}
//       <div>
//         <label className="block text-sm font-medium mb-1">Email Address</label>
//         <input
//           type="email"
//           value={address.email || ""}
//           onChange={(e) => handleInputChange("email", e.target.value)}
//           className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent"
//           placeholder="john@example.com"
//         />
//       </div>

//       <div>
//         <label className="block text-sm font-medium mb-1">Address</label>
//         <input
//           type="text"
//           value={address.address}
//           onChange={(e) => handleInputChange("address", e.target.value)}
//           className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent"
//           placeholder="123 Main St"
//         />
//       </div>

//       <div className="grid grid-cols-2 gap-3">
//         <div>
//           <label className="block text-sm font-medium mb-1">City</label>
//           <input
//             type="text"
//             value={address.city}
//             onChange={(e) => handleInputChange("city", e.target.value)}
//             className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent"
//             placeholder="Atlanta"
//           />
//         </div>
//         <div>
//           <label className="block text-sm font-medium mb-1">State</label>
//           <select
//             value={address.state}
//             onChange={(e) => handleInputChange("state", e.target.value)}
//             className="w-full p-3 border rounded-lg bg-white focus:ring-2 focus:ring-yellow-500 focus:border-transparent"
//             style={{ appearance: "menulist" }}
//           >
//             <option value="">Select State</option>
//             {US_STATES.map((state) => (
//               <option key={state.code} value={state.code}>
//                 {state.name}
//               </option>
//             ))}
//           </select>
//         </div>
//       </div>

//       <div>
//         <label className="block text-sm font-medium mb-1">ZIP Code</label>
//         <input
//           type="text"
//           value={address.zipCode}
//           onChange={(e) => handleInputChange("zipCode", e.target.value)}
//           className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent"
//           placeholder="30309"
//         />
//       </div>

//       {address.state && (
//         <div className="text-sm text-green-600">
//           ✓ State selected:{" "}
//           {US_STATES.find((s) => s.code === address.state)?.name}
//         </div>
//       )}

//       <button
//         onClick={handleContinue}
//         disabled={!isFormValid()}
//         className="w-full bg-gradient-to-r from-yellow-400 to-yellow-600 text-black py-3 rounded-lg font-semibold disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200"
//       >
//         Continue to Payment
//       </button>
//     </div>
//   );
// };

// export default AddressForm;

import React, { useState } from "react";
import { US_STATES } from "../../data/state";

const labelClassName =
  "mb-1.5 flex items-center gap-1.5 text-[9px] font-semibold uppercase tracking-[0.14em] text-slate-400";
const inputClassName =
  "h-11 w-full rounded-xl border border-white/10 bg-white/[0.06] px-3 text-base text-white outline-none transition placeholder:text-slate-600 hover:border-white/20 focus:border-amber-400/70 focus:bg-white/[0.08] focus:ring-2 focus:ring-amber-400/15 focus:shadow-[0_0_0_1px_rgba(251,191,36,0.25)] sm:h-10 sm:text-[13px]";
const sectionClassName =
  "rounded-2xl border border-white/10 bg-white/[0.025] p-3 sm:p-4 transition-colors hover:border-white/[0.14]";
const FieldIcon = ({ children }) => (
  <span className="text-amber-400/70">{children}</span>
);

const AddressForm = ({
  address,
  setAddress,
  onContinue,
  fetchShippingRates,
}) => {
  // NEW: State for autocomplete
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [citySuggestions, setCitySuggestions] = useState([]);
  const [showCitySuggestions, setShowCitySuggestions] = useState(false);
  const [addressError, setAddressError] = useState("");
  const [selectedAddressDisplay, setSelectedAddressDisplay] = useState("");
  const [hasSelectedAddress, setHasSelectedAddress] = useState(false);
  const [hasSelectedCity, setHasSelectedCity] = useState(false);

  // NEW: Your Geoapify API key
  const GEOAPIFY_API_KEY = process.env.REACT_APP_GEOAPIFY_KEY;

  const handleInputChange = (field, value) => {
    setAddress((prev) => {
      const nextAddress = { ...prev, [field]: value };
      if (field === "firstName" || field === "lastName") {
        nextAddress.name = [
          field === "firstName" ? value : prev.firstName,
          field === "lastName" ? value : prev.lastName,
        ]
          .filter(Boolean)
          .join(" ")
          .trim();
      }
      return nextAddress;
    });
  };

  const fetchCitySuggestions = async (input) => {
    if (!hasSelectedAddress || hasSelectedCity || input.length < 3 || !GEOAPIFY_API_KEY) {
      setCitySuggestions([]);
      setShowCitySuggestions(false);
      return;
    }

    try {
      const response = await fetch(
        `https://api.geoapify.com/v1/geocode/autocomplete?text=${encodeURIComponent(
          input
        )}&apiKey=${GEOAPIFY_API_KEY}&limit=5&filter=countrycode:us`
      );
      if (!response.ok) {
        throw new Error(`Geoapify city request failed (${response.status})`);
      }
      const data = await response.json();
      const uniqueCities = Array.from(
        new Map(
          (data.features || [])
            .map((feature) => ({
              city:
                feature.properties.city ||
                feature.properties.town ||
                feature.properties.municipality ||
                feature.properties.name ||
                "",
              state:
                feature.properties.state_code ||
                US_STATES.find(
                  (state) =>
                    state.name.toLowerCase() ===
                    feature.properties.state?.toLowerCase()
                )?.code ||
                address.state,
            }))
            .filter(
              (item) =>
                item.city &&
                item.state &&
                (!address.state || item.state === address.state)
            )
            .map((item) => [`${item.city}-${item.state}`, item])
        ).values()
      );
      setCitySuggestions(uniqueCities);
      setShowCitySuggestions(uniqueCities.length > 0);
    } catch (error) {
      console.error("Error fetching city suggestions:", error);
      setCitySuggestions([]);
      setShowCitySuggestions(false);
    }
  };

  const handleCityChange = (value) => {
    setHasSelectedCity(false);
    handleInputChange("city", value);
    fetchCitySuggestions(value);
  };

  const selectCity = (suggestion) => {
    setAddress((prev) => ({
      ...prev,
      city: suggestion.city,
      state: suggestion.state || prev.state,
    }));
    setHasSelectedCity(true);
    setShowCitySuggestions(false);
    setCitySuggestions([]);
  };

  const isFormValid = () => {
    return (
      address.firstName &&
      address.lastName &&
      address.email &&
      address.address &&
      address.state &&
      address.zipCode &&
      hasSelectedAddress
    );
  };

  const handleContinue = async () => {
    if (fetchShippingRates) {
      const canContinue = await fetchShippingRates(address);
      if (!canContinue) return;
    }
    onContinue();
  };

  // NEW: Fetch address suggestions from Geoapify
  const fetchAddressSuggestions = async (input) => {
    if (input.length < 3) {
      setSuggestions([]);
      setShowSuggestions(false);
      return;
    }

    if (!GEOAPIFY_API_KEY) {
      setSuggestions([]);
      setShowSuggestions(false);
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(
        `https://api.geoapify.com/v1/geocode/autocomplete?text=${encodeURIComponent(
          input
        )}&apiKey=${GEOAPIFY_API_KEY}&limit=5&filter=countrycode:us`
      );

      if (!response.ok) {
        throw new Error(`Geoapify request failed (${response.status})`);
      }

      const data = await response.json();
      setSuggestions(data.features || []);
      setShowSuggestions(true);
    } catch (error) {
      console.error("Error fetching address suggestions:", error);
      setSuggestions([]);
    } finally {
      setLoading(false);
    }
  };

  // NEW: Handle address selection from dropdown
  const selectAddress = (suggestion) => {
    const props = suggestion.properties;
    const composedStreet = [props.housenumber, props.street]
      .filter(Boolean)
      .join(" ")
      .trim();
    const addressLine = (props.address_line1 || "").trim();
    const deliverableStreet =
      composedStreet ||
      (/^\d+\s+\S+/.test(addressLine) ? addressLine : "") ||
      (/^P\.?\s*O\.?\s+Box\s+\S+/i.test(addressLine) ? addressLine : "");

    if (!deliverableStreet) {
      setAddressError(
        "Select a complete street address with a house number. For a P.O. Box, enter the box number—not only the post office name."
      );
      setSuggestions([]);
      setShowSuggestions(false);
      return;
    }

    // Geoapify may return city as null for unincorporated areas.
    // Fall back to suburb, town, or the existing manually-typed city.
    const resolvedCity =
      props.city || props.suburb || props.town || props.municipality || address.city || "";
    const resolvedState =
      props.state_code ||
      US_STATES.find(
        (state) => state.name.toLowerCase() === props.state?.toLowerCase()
      )?.code ||
      address.state ||
      "";

    setAddress({
      ...address,
      address: deliverableStreet,
      city: resolvedCity,
      state: resolvedState,
      zipCode: props.postcode || address.zipCode || "",
    });

    setAddressError("");
    setHasSelectedAddress(true);
    setHasSelectedCity(Boolean(resolvedCity));
    setSelectedAddressDisplay(
      [
        deliverableStreet,
        resolvedCity,
        resolvedState,
        props.postcode || address.zipCode,
      ]
        .filter(Boolean)
        .join(", ")
    );
    setSuggestions([]);
    setShowSuggestions(false);
  };

  // NEW: Modified address input handler
  const handleAddressChange = (value) => {
    setAddressError("");
    setSelectedAddressDisplay("");
    setHasSelectedAddress(false);
    setHasSelectedCity(false);
    // Editing the street field invalidates whatever city/state/zip came
    // from the previously selected suggestion, so clear them too.
    setAddress((prev) => ({
      ...prev,
      address: value,
      city: "",
      state: "",
      zipCode: "",
    }));
    fetchAddressSuggestions(value);
  };

  return (
    <div className="space-y-4">
      <div className={sectionClassName}>
        <div className="mb-3.5 flex items-center gap-2 border-b border-white/[0.06] pb-2.5">
          <span className="flex h-[22px] w-[22px] items-center justify-center rounded-lg bg-amber-400/10 text-amber-400">
            <svg className="h-3.5 w-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
          </span>
          <div>
            <p className="text-[11px] font-semibold text-white">Contact details</p>
            <p className="text-[10px] text-slate-500">
              Used for order and delivery updates
            </p>
          </div>
        </div>
        <div className="grid grid-cols-1 gap-3 min-[430px]:grid-cols-2">
          <div>
            <label className={labelClassName}>
              <FieldIcon>
                <svg className="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
              </FieldIcon>
              First Name
            </label>
            <input
              type="text"
              value={address.firstName || ""}
              onChange={(e) => handleInputChange("firstName", e.target.value)}
              className={inputClassName}
              placeholder="John"
              autoComplete="given-name"
            />
          </div>

          <div>
            <label className={labelClassName}>
              <FieldIcon>
                <svg className="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
              </FieldIcon>
              Last Name
            </label>
            <input
              type="text"
              value={address.lastName || ""}
              onChange={(e) => handleInputChange("lastName", e.target.value)}
              className={inputClassName}
              placeholder="Doe"
              autoComplete="family-name"
            />
          </div>

          <div className="min-[430px]:col-span-2">
            <label className={labelClassName}>
              <FieldIcon>
                <svg className="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </FieldIcon>
              Email Address
            </label>
            <input
              type="email"
              value={address.email || ""}
              onChange={(e) => handleInputChange("email", e.target.value)}
              className={inputClassName}
              placeholder="john@example.com"
              autoComplete="email"
            />
          </div>
        </div>
      </div>

      <div className={sectionClassName}>
        <div className="mb-3.5 flex items-center gap-2 border-b border-white/[0.06] pb-2.5">
          <span className="flex h-6 w-6 items-center justify-center rounded-lg bg-amber-400/10 text-amber-400">
            <svg className="h-3.5 w-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
              <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
          </span>
          <div>
            <p className="text-[11px] font-semibold text-white">Delivery address</p>
            <p className="text-[10px] leading-snug text-slate-500">
              Select a suggestion with a street number
            </p>
          </div>
        </div>

        <div className="relative">
          <label className={labelClassName}>
            <FieldIcon>
              <svg className="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
            </FieldIcon>
            Street Address
          </label>
          <input
            type="text"
            value={address.address}
            onChange={(e) => handleAddressChange(e.target.value)}
            onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
            className={`${inputClassName} pr-10`}
            placeholder="123 Main Street"
            autoComplete="street-address"
          />

          {loading && (
            <div className="absolute right-3 top-[28px] text-amber-400">
              <div className="h-3.5 w-3.5 animate-spin rounded-full border-2 border-amber-400 border-t-transparent" />
            </div>
          )}

          {addressError && (
            <p className="mt-2 rounded-lg border border-red-500/20 bg-red-500/10 px-3 py-2 text-[10px] leading-relaxed text-red-300">
              {addressError}
            </p>
          )}
          {!hasSelectedAddress && address.address && !addressError && (
            <p className="mt-2 rounded-lg border border-amber-400/20 bg-amber-400/10 px-3 py-2 text-[10px] leading-relaxed text-amber-200">
              Select a suggested address before continuing.
            </p>
          )}
          {selectedAddressDisplay && (
            <div className="mt-2 rounded-lg border border-emerald-400/20 bg-emerald-400/10 px-3 py-2 text-[10px] leading-relaxed text-emerald-300">
              ✓ {selectedAddressDisplay}
            </div>
          )}
          {showSuggestions && suggestions.length > 0 && (
            <div className="absolute z-20 mt-1.5 max-h-56 w-full overflow-y-auto rounded-xl border border-slate-200 bg-white p-1 shadow-2xl">
              {suggestions.map((suggestion, index) => {
                const isLocationOnly =
                  !suggestion.properties.housenumber &&
                  !/^\d+\s+\S+/.test(
                    suggestion.properties.address_line1 || ""
                  );
                return (
                  <button
                    type="button"
                    key={index}
                    onMouseDown={(event) => event.preventDefault()}
                    onClick={() => selectAddress(suggestion)}
                    className="block w-full rounded-lg px-3 py-2 text-left transition hover:bg-amber-50"
                  >
                    <span className="block text-[11px] font-medium leading-snug text-slate-900">
                      {suggestion.properties.formatted}
                    </span>
                    {isLocationOnly && (
                      <span className="mt-1 block text-[9px] text-amber-700">
                        Location only—choose a result with a street number
                      </span>
                    )}
                  </button>
                );
              })}
            </div>
          )}
        </div>

        <div className="mt-3.5 grid grid-cols-1 gap-3 min-[430px]:grid-cols-2">
          <div className="relative min-[430px]:col-span-2 sm:col-span-1">
            <label className={labelClassName}>
              <FieldIcon>
                <svg className="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2M5 21H3m4-13h10M7 12h10M7 17h6" />
                </svg>
              </FieldIcon>
              City
            </label>
            <input
              type="text"
              value={address.city}
              onChange={(e) => handleCityChange(e.target.value)}
              onBlur={() => setTimeout(() => setShowCitySuggestions(false), 200)}
              readOnly={hasSelectedAddress && hasSelectedCity}
              className={`${inputClassName} ${hasSelectedAddress && hasSelectedCity ? "cursor-not-allowed opacity-80" : ""}`}
              placeholder="Atlanta"
              autoComplete="address-level2"
            />
            {showCitySuggestions && citySuggestions.length > 0 && (
              <div className="absolute z-20 mt-1.5 max-h-44 w-full overflow-y-auto rounded-xl border border-slate-200 bg-white p-1 shadow-2xl">
                {citySuggestions.map((suggestion, index) => (
                  <button
                    type="button"
                    key={`${suggestion.city}-${suggestion.state}-${index}`}
                    onMouseDown={(event) => event.preventDefault()}
                    onClick={() => selectCity(suggestion)}
                    className="block w-full rounded-lg px-3 py-2 text-left text-[11px] font-medium leading-snug text-slate-900 transition hover:bg-amber-50"
                  >
                    {suggestion.city}, {suggestion.state}
                  </button>
                ))}
              </div>
            )}
          </div>
          <div>
            <label className={labelClassName}>State</label>
            <select
              value={address.state}
              onChange={(e) => handleInputChange("state", e.target.value)}
              disabled={hasSelectedAddress}
              className={`${inputClassName} appearance-auto ${hasSelectedAddress ? "cursor-not-allowed opacity-80" : ""}`}
              autoComplete="address-level1"
            >
              <option value="" className="bg-slate-900">Select</option>
              {US_STATES.map((state) => (
                <option key={state.code} value={state.code} className="bg-slate-900">
                  {state.name}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label className={labelClassName}>ZIP Code</label>
            <input
              type="text"
              inputMode="numeric"
              value={address.zipCode}
              onChange={(e) => handleInputChange("zipCode", e.target.value)}
              readOnly={hasSelectedAddress}
              className={`${inputClassName} ${hasSelectedAddress ? "cursor-not-allowed opacity-80" : ""}`}
              placeholder="30309"
              autoComplete="postal-code"
              maxLength={10}
            />
          </div>
        </div>
      </div>

      {address.state && (
        <div className="flex items-center gap-2 px-1 text-[10px] text-emerald-400">
          <span className="flex h-4 w-4 items-center justify-center rounded-full bg-emerald-400/15 text-[8px]">
            ✓
          </span>
          Shipping to {US_STATES.find((s) => s.code === address.state)?.name}
        </div>
      )}

      <button
        type="button"
        onClick={handleContinue}
        disabled={!isFormValid() || loading}
        className="flex h-12 w-full items-center justify-center rounded-xl bg-gradient-to-r from-amber-300 via-amber-400 to-yellow-500 px-4 text-sm font-bold text-slate-950 shadow-lg shadow-amber-500/10 transition hover:brightness-105 active:scale-[0.99] disabled:cursor-not-allowed disabled:opacity-40 sm:h-11 sm:text-xs"
      >
        Continue to Payment
        <svg className="ml-2 h-3.5 w-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
        </svg>
      </button>
    </div>
  );
};

export default AddressForm;
